module.exports = __webpack_public_path__ + "img/iv_b2_pic1.77d8020b.png";